module.exports = __webpack_public_path__ + "img/0Q3A5468_L_WoodMatted_MockedUp.c4227698.jpg";